<template>
  <div module-item :class="info.type">
    <div class="video-wrap">
      <iframe v-if="info.type === 'youtube'" :src="`https://www.youtube.com/embed/${info.value.linkId}`" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <iframe v-else :src="`https://player.vimeo.com/video/${info.value.linkId}?autoplay=1&loop=1&muted=1`" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>

      </iframe>
    </div>
    <div class="desc" v-html="enterToBr(info.value.desc)" v-if="info.value.desc"></div>
  </div>
</template>

<script>

export default {
  name: 'LinkUpload',
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
};
</script>

